export default __webpack_public_path__ + "static/media/832.2545323b.png";